var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emd-copy" },
    [
      _c("strong", { staticClass: "emd-text _color_default" }, [
        _vm._v(_vm._s(_vm.fieldData.fieldName + ": ")),
      ]),
      _c("span", [_vm._v(_vm._s(_vm.fieldData.value))]),
      _vm.fieldData.copy
        ? _c("emd-copy", {
            attrs: {
              item: _vm.fieldData.value,
              showLabel: false,
              textLeft: true,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }